import { Outlet, createRootRoute, useLocation } from "@tanstack/react-router";
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { Header } from "@/components/header";
import { Sidebar } from "@/components/sidebar";
import { Toaster } from "@/components/ui/sonner";

const allowSidebar = [
	"/",
	"/pack",
	"/deck",
	"/deck/list",
	"/send",
	"/support",
	"/support/submit",
];
const allowHeader = [
	"/",
	"/pack",
	"/deck",
	"/deck/list",
	"/send",
	"/support",
	"/support/submit",
];

const isAdminPath = (pathname: string) => pathname.startsWith("/admin");

export const Route = createRootRoute({
	component: () => {
		const location = useLocation();
		const showHeader =
			allowHeader.includes(location.pathname) || isAdminPath(location.pathname);

		return (
			<div className="h-full flex">
				{/* sidebar */}
				{allowSidebar.includes(location.pathname) && <Sidebar />}
				{/* main */}
				<div className="flex-1 flex flex-col overflow-y-auto">
					{showHeader && <Header />}
					<Outlet />
				</div>
				{/* <TanStackRouterDevtools /> */}
				<Toaster />
			</div>
		);
	},
});
